import CashierServiceModel from "../CashierServiceModel";
import CustomerModel from "./CustomerModel";
import UserModel from "./UserModel";
import InvoiceItemCollection from "../../collections/cashier/InvoiceItemCollection";

export default class InvoiceModel extends CashierServiceModel {

  modelName() {
    return 'invoices';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.create = process.env.VUE_APP_CASHIER_REPOSITORY_URL + '/api/v1/public/' + this.modelName();
    return routes;
  }

  defaults() {
    return {
      id: null,
      user_id: null,
      customer_id: null,
      auto_advance: null,
      collection_method: null,
      custom_fields: null,
      description: null,
      due_date: null,
      metadata: null,
      statement_descriptor: null,
      credit: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      user: null,
      customer: null,
      invoice_items: [],
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      auto_advance: Boolean,
      collection_method: (val) => (this.nullStringMutator(val)),
      custom_fields: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      due_date: (val) => (this.nullStringMutator(val)),
      metadata: (val) => (this.nullStringMutator(val)),
      statement_descriptor: (val) => (this.nullStringMutator(val)),
      credit: Boolean,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getUser() {
    return this.getRelatedModel(UserModel, 'user');
  }

  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }

  getInvoiceItems() {
    return this.getRelatedCollection(new InvoiceItemCollection(), 'invoice_items');
  }

}
